import { combineReducers } from "redux";
import { calendarSlice } from "../app/reduxSlices/BaseInfo/calendarSlice";
import { objectsSlice } from "../app/reduxSlices/objectsSlice";

export const baseInfoReducer = combineReducers({

  dormDashboard: objectsSlice({ name: "dormDashboard" }).reducer,

  exportCsvResult: objectsSlice({ name: "exportCsvResult" }).reducer,
  // errorsResult: objectsSlice({ name: "errorsResult" }).reducer,

  users: objectsSlice({ name: "users" }).reducer,
  teachers: objectsSlice({ name: "teachers" }).reducer,
  operators: objectsSlice({ name: "operators" }).reducer,
  profileFileDescription: objectsSlice({ name: "profileFileDescription" }).reducer,
  golestanUsers: objectsSlice({ name: "golestanUsers" }).reducer,
  detailUsers: objectsSlice({ name: "detailUsers" }).reducer,
  univercities: objectsSlice({ name: "univercities" }).reducer,

  dorms: objectsSlice({ name: "dorms" }).reducer,
  blocks: objectsSlice({ name: "blocks" }).reducer,
  dormBlocks: objectsSlice({ name: "dormBlocks" }).reducer,
  dormTermBlocks: objectsSlice({ name: "dormTermBlocks" }).reducer,
  rooms: objectsSlice({ name: "rooms" }).reducer,
  blockRooms: objectsSlice({ name: "blockRooms" }).reducer,

  collages: objectsSlice({ name: "collages" }).reducer,
  workUnit: objectsSlice({ name: "workUnit" }).reducer,
  fields: objectsSlice({ name: "fields" }).reducer,
  groups: objectsSlice({ name: "groups" }).reducer,
  subGroups: objectsSlice({ name: "subGroups" }).reducer,
  devices: objectsSlice({ name: "devices" }).reducer,
  deviceTypes: objectsSlice({ name: "deviceTypes" }).reducer,
  deviceGroups: objectsSlice({ name: "deviceGroups" }).reducer,
  terms: objectsSlice({ name: "terms" }).reducer,
  activeTerms: objectsSlice({ name: "activeTerms" }).reducer,
  years: objectsSlice({ name: "years" }).reducer,
  semesters: objectsSlice({ name: "semesters" }).reducer,
  grades: objectsSlice({ name: "grades" }).reducer,
  accounts: objectsSlice({ name: "accounts" }).reducer,
  banks: objectsSlice({ name: "banks" }).reducer,

  calendars: objectsSlice({ name: "calendars" }).reducer,
  // calendars: calendarSlice.reducer,

  roles: objectsSlice({ name: "roles" }).reducer,
  menus: objectsSlice({ name: "menus" }).reducer,
  tabMenus: objectsSlice({ name: "tabMenus" }).reducer,
  permissions: objectsSlice({ name: "permissions" }).reducer,
  groupPermissions: objectsSlice({ name: "groupPermissions" }).reducer,
  menuPermissions: objectsSlice({ name: "menuPermissions" }).reducer,
  tabPermissions: objectsSlice({ name: "tabPermissions" }).reducer,
  rolePermissions: objectsSlice({ name: "rolePermissions" }).reducer,
  dormPermissions: objectsSlice({ name: "dormPermissions" }).reducer,

  workUnits: objectsSlice({ name: "workUnits" }).reducer,
  workUnitPermissions: objectsSlice({ name: "workUnitPermissions" }).reducer,

  blogs: objectsSlice({ name: "blogs" }).reducer,
  bankAccountSubGroups: objectsSlice({ name: "bankAccountSubGroups" }).reducer,
  provinces: objectsSlice({ name: "provinces" }).reducer,
  towns: objectsSlice({ name: "towns" }).reducer,
  logs: objectsSlice({ name: "logs" }).reducer,
  emsSettings: objectsSlice({ name: "emsSettings" }).reducer,
  correspondenceCategory: objectsSlice({ name: "correspondenceCategory" }).reducer,
  correspondence: objectsSlice({ name: "correspondence" }).reducer,
  correspondenceLetter: objectsSlice({ name: "correspondenceLetter" }).reducer,
  correspondenceTracker: objectsSlice({ name: "correspondenceTracker" }).reducer,
  correspondenceStatusTracker: objectsSlice({ name: "correspondenceStatusTracker" }).reducer,

  authenticationTypes: objectsSlice({ name: "authenticationTypes" }).reducer,
  transactionTypes: objectsSlice({ name: "transactionTypes" }).reducer,


  rankingSettings: objectsSlice({ name: "rankingSettings" }).reducer,
  rankingParameterTypeGrade: objectsSlice({ name: "rankingParameterTypeGrade" }).reducer,
  rankingParameterTypeFatherJob: objectsSlice({ name: "rankingParameterTypeFatherJob" }).reducer,
  rankingParameterTypeSupportingInstitue: objectsSlice({ name: "rankingParameterTypeSupportingInstitue" }).reducer,
  rankingParameterTypeSpecialCondition: objectsSlice({ name: "rankingParameterTypeSpecialCondition" }).reducer,
  rankingParameterTypeDistance: objectsSlice({ name: "rankingParameterTypeDistance" }).reducer,
  rankingParameterTypeMartyrOrVeterans: objectsSlice({ name: "rankingParameterTypeMartyrOrVeterans" }).reducer,
  rankingParameterTypeOther: objectsSlice({ name: "rankingParameterTypeOther" }).reducer,
  rankingParameterTypMilitaryServiceId: objectsSlice({ name: "rankingParameterTypMilitaryServiceId" }).reducer,
  rankingParameterTypChildsCount: objectsSlice({ name: "rankingParameterTypChildsCount" }).reducer,

  identityCardFrontFileDescription: objectsSlice({ name: "identityCardFrontFileDescription" }).reducer,
  identityCardBackFileDescription: objectsSlice({ name: "identityCardBackFileDescription" }).reducer,
  certificateIdentityPageOneFileDescription: objectsSlice({ name: "certificateIdentityPageOneFileDescription" }).reducer,
  certificateIdentityPageTwoFileDescription: objectsSlice({ name: "certificateIdentityPageTwoFileDescription" }).reducer,
  certificateIdentityPageThreeFileDescription: objectsSlice({ name: "certificateIdentityPageThreeFileDescription" }).reducer,
  militaryServiceLicenseFileDescription: objectsSlice({ name: "militaryServiceLicenseFileDescription" }).reducer,
  supportingInstitueLicenseFileDescription: objectsSlice({ name: "supportingInstitueLicenseFileDescription" }).reducer,
  specialConditionLicenseFileDescription: objectsSlice({ name: "specialConditionLicenseFileDescription" }).reducer,
  martyrOrVeteransLicenseFileDescription: objectsSlice({ name: "martyrOrVeteransLicenseFileDescription" }).reducer,
  otherLicenseFileDescription: objectsSlice({ name: "otherLicenseFileDescription" }).reducer,
  recognizanceFileDescription: objectsSlice({ name: "recognizanceFileDescription" }).reducer,
  studentCardFileDescription: objectsSlice({ name: "studentCardFileDescription" }).reducer,
  fatherJobCertificateFileDescription: objectsSlice({ name: "fatherJobCertificateFileDescription" }).reducer,
  motherJobCertificateIdFileDescription: objectsSlice({ name: "motherJobCertificateIdFileDescription" }).reducer,
});
